import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulkhoardingComponent } from './bulkhoarding/bulkhoarding.component';
import { NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [BulkhoardingComponent],
  imports: [
    CommonModule,
    NgbPaginationModule,
    NgbAlertModule,
    FormsModule
  ]
})
export class BulkhoardingModule { }
